import React from 'react';
import { Typography, Container, Paper, Box } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

const About: React.FC = () => {
  return (
    <Container maxWidth="lg">
      <Box sx={{ mt: 0, mb: 4 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
          <InfoIcon sx={{ mr: 1 }} />
          <Typography variant="h4" component="h1">
            About
          </Typography>
        </Box>

        <Paper sx={{ p: 4 }}>
          <Typography variant="body1" color="text.secondary">
            Content coming soon.
          </Typography>
        </Paper>
      </Box>
    </Container>
  );
};

export default About;
